import React, {useContext, useState} from 'react';
import {useIntl} from 'react-intl';

import {TextField} from '@mui/material';

import CustomButton from "components/CustomButton";

import FilterAutocompleteContainer from "./FilterAutocompleteContainer";
import FreeTextFilterAutocomplete from "./FreeTextFilterAutocomplete";

import {OrderListContext} from "../../context/OrderListContext";

import {sortOn} from "utils/sortOn";

function FilterElements() {
    const intl = useIntl();
    const {filterMenuSelected, filters, organizationCouponCodes, selectedFilters, setSelectedFilters} = useContext(OrderListContext);

    const [sellerIdInput, setSellerIdInput] = useState("");
    const [couponCodeInput, setCouponCodeInput] = useState("");
    const [receiptValueInput, setReceiptValueInput] = useState("");

    function checkIfFilterExist(element) {
        return selectedFilters.some(filter => filter.id === element.id);
    }

    function handleAddSelectedFilter(element) {
        if (!checkIfFilterExist(element)) {
            setSelectedFilters([...selectedFilters, element]);
        }
    }

    function addFreeTextFilter(type, value, setValue, clearAfterAdd = true) {
        const trimmedValue = value.trim();

        if (!trimmedValue) {
            return;
        }

        handleAddSelectedFilter({"@type": type, "id": trimmedValue, "name": trimmedValue});

        if (clearAfterAdd) {
            setValue("");
        }
    }

    if (filterMenuSelected === "ReceiptValue") {
        return (
            <FilterAutocompleteContainer>
                <TextField
                    placeholder={intl.formatMessage({id: "retailer.product.list.filter.receiptvalue.placeholder"})}
                    variant="standard"
                    sx={{width: '100%'}}
                    value={receiptValueInput}
                    onChange={(e) => setReceiptValueInput(e.target.value)}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            addFreeTextFilter("ReceiptValue", receiptValueInput, setReceiptValueInput, false);
                            e.preventDefault();
                        }
                    }}
                />
            </FilterAutocompleteContainer>
        );
    }

    if (filterMenuSelected === "SellerId") {
        return (
            <FreeTextFilterAutocomplete
                id="registration-number-input"
                value={sellerIdInput}
                onValueChange={setSellerIdInput}
                placeholderId="retailer.product.list.filter.sellerId.placeholder"
                onAdd={() => addFreeTextFilter("SellerId", sellerIdInput, setSellerIdInput)}
            />
        );
    }

    if (filterMenuSelected === "CouponCode") {
        return (
            <FreeTextFilterAutocomplete
                id="coupon-code-input"
                options={organizationCouponCodes ?? []}
                value={couponCodeInput}
                onValueChange={setCouponCodeInput}
                placeholderId="retailer.product.list.filter.couponcode.placeholder"
                onAdd={() => addFreeTextFilter("CouponCode", couponCodeInput, setCouponCodeInput)}
            />
        );
    }

    if (filters[filterMenuSelected]) {
        const sortedFilterElements = filters[filterMenuSelected].sort(sortOn("name"));

        return (
            <div style={{
                display: 'flex',
                gap: '8px',
                padding: '0px 0px',
                marginTop:'24px',
                flexWrap: 'wrap'
            }}>
                {sortedFilterElements.map(element => (
                    <CustomButton
                        color={checkIfFilterExist(element) ? 'blue' : 'default'}
                        rounded
                        key={element.id}
                        onClick={() => handleAddSelectedFilter(element)}
                        variant={checkIfFilterExist(element) ? "contained" : "outlined"}
                    >
                        {element.name || element.value}
                    </CustomButton>
                ))}
            </div>
        );
    }

    return null;
}

export default FilterElements;
